__turbopack_context__.v({
  "body": "okveUa_body",
  "content": "okveUa_content",
  "header": "okveUa_header",
  "title": "okveUa_title",
});
